import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=e4a7c028&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a7c028')) {
      api.createRecord('e4a7c028', component.options)
    } else {
      api.reload('e4a7c028', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=e4a7c028&", function () {
      api.rerender('e4a7c028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/product/IndexPage.vue"
export default component.exports